import './FileItemForm.css';

import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../../../App';
import B2BFormContainer from '../../../b2b-common/B2BFormContainer';
import { useContentContext } from '../../../layout/Layout';
import EditText from '../../../b2b-common/EditText';
import BooleanIconToggle from '../../../b2b-common/BooleanIconToggle';
import { Star, StarBorder } from '@mui/icons-material';
import FieldComponent from '../../../b2b-common/FieldComponent';
import { showNotification } from '../../../b2b-common/Notification';
import { createItem, updateItem } from '../../../../services/b2b-logbook-apiServices';
import UploadFile from './UploadFile';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const FileItemForm = ({ logbook, folder, itemFile = null, onClose, onSaved }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const blankFile = {
        logBookItemType: 'FILE',
        logBookId: logbook.logBookId,
        logBookFolderId: folder ? folder.logBookFolderId : 0,
        logBookItemId: 0,
        // logBook: logbook,
        // logBookFolder: folder ?? {},
        logBookItemCreationTime: new Date().toISOString(), // Converting to ISO string for LocalDateTime
        logBookItemName: `${t('New File')}`,
        logBookItemDescription: '',
        logBookItemStarred: false // Assuming a default value
    }
    const [currentFile, setCurrentFile] = useState(itemFile || blankFile);
    const [selectedFileToUpload, setSelectedFileToUpload] = useState(null);

    useEffect(() => {
        if (itemFile) {
            setCurrentFile(itemFile);
        }
    }, [itemFile]);

    useEffect(() => {
        if (folder && (folder.logBookFolderId !== currentFile.logBookFolderId)) {
            setCurrentFile({ ...currentFile, logBookFolderId: folder.logBookFolderId });
        }
    }, [folder]);

    const handleSave = async () => {
        if (itemFile === null) { // Create
            if (!selectedFileToUpload) {
                showNotification(setNotification, t('Please select a file to upload.'), 'error', 5000);
                return;
            } else {
                try {
                    // console.log('folder:', folder);
                    // console.log('Creating file:', currentFile);
                    const updatedItem = await createItem(loginData.accessToken, currentFile.logBookId, currentFile.logBookFolderId, currentFile, selectedFileToUpload);
                    // console.log('File created:', updatedItem);
                    showNotification(setNotification, t('File created successfully.'), 'success', 3000);
                    onSaved && onSaved(updatedItem);
                } catch (error) {
                    console.error('Error creating file:', error);
                    showNotification(setNotification, t('Error creating file: ') + error.response.statusText, 'error', 5000);
                }
            }
        } else { // Update
            try {
                const updatedItem = await updateItem(loginData.accessToken, currentFile.logBookId, currentFile.logBookFolderId, currentFile.logBookItemId, currentFile, selectedFileToUpload);
                showNotification(setNotification, t('File updated successfully.'), 'success', 3000);
                onSaved && onSaved(updatedItem);
            } catch (error) {
                console.error('Error updating file:', error);
                showNotification(setNotification, t('Error updating file: ') + error.response.statusText, 'error', 5000);
            }
        }
    }

    const handleFileChange = (fileToUpload) => {
        // console.log('Selected file:', fileToUpload);
        setSelectedFileToUpload(fileToUpload);
    };

    return (
        <B2BFormContainer title={itemFile ? t('File Details') : t('New File')} onClose={onClose}
            showDivider={false}
            buttonsConfig={[
                { label: t('Save'), onClick: handleSave },
            ]}
            className='file-item-form'
        >
            <div>
                <EditText object={currentFile} objectField='logBookItemName' setObjectField={setCurrentFile} label={t('File Name')} />
                <FieldComponent label={t('Favorite')} className={'file-item-starred-toggle'}
                    component={
                        <BooleanIconToggle
                            value={currentFile.logBookItemStarred}
                            trueIcon={<Star />}
                            falseIcon={<StarBorder />}
                            onChange={(value) => setCurrentFile({ ...currentFile, logBookItemStarred: value })}

                        />
                    }
                />
            </div>
            <EditText object={currentFile} objectField='logBookItemDescription' setObjectField={setCurrentFile} label={t('Description')} multiline={true} rows={3} />
            <UploadFile itemFile={currentFile} onFileChange={handleFileChange} />
        </B2BFormContainer>
    )
}

export default FileItemForm;